// extracted by mini-css-extract-plugin
module.exports = {"AddSnippetBtn":"AddSnippetBtn_AddSnippetBtn__JLzXk","disabled":"AddSnippetBtn_disabled__238BA"};